import { Component, ElementRef, EventEmitter, Input, input, Output, ViewChild } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';


@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})

export class ConfirmDialogComponent {
  @Input() warningMessages: string[] = [];
  @Output() confirm = new EventEmitter<boolean>();

  @ViewChild('yesButton') yesButton!: ElementRef;


  ngAfterViewInit() {
    this.yesButton.nativeElement.focus();
  }

  onConfirm(): void {
    this.confirm.emit(true);
  }

  onCancel(): void {
    this.confirm.emit(false);
  }
}
